<div class="content-with-side-menu">
    <div class="row no-gutters">
        <div class="col-md-auto">
            <app-transaction-report-search-criteria
                hznTestId="transaction-report-filters"
                [filters]="filters"
                [searchForm]="searchForm"
            >
            </app-transaction-report-search-criteria>
        </div>

        <div class="col">
            @if (!noItems && !isBusy) {
                <div
                    class="row no-gutters top-panel height-60 line-height-40 padding-10"
                >
                    <div class="col">
                        <button
                            class="btn btn-success"
                            bcClick
                            hznTestId="transaction-report-generate"
                            (clicked)="getReport()"
                        >
                            {{ "TransactionReport.Generate" | translate }}
                        </button>
                    </div>
                </div>
            }

            <div>
                <bcu-local-spinner
                    [size]="50"
                    [visible]="isBusy"
                ></bcu-local-spinner>

                <div
                    class="list-group list-group-flush grid"
                    infinite-scroll
                    [infiniteScrollDistance]="0.1"
                    [infiniteScrollThrottle]="300"
                    [infiniteScrollDisabled]="isBusy"
                    (scrolled)="onScroll()"
                >
                    @if (!noItems && !isBusy) {
                        <div
                            class="list-group-item list-group-item-action flex-column align-items-start grid-header"
                        >
                            <div class="row">
                                <div class="col-md-1 col-sm-1 grid-column">
                                    {{
                                        "TransactionReport.DateHeader"
                                            | translate
                                    }}
                                </div>
                                <div class="col-md-1 col-sm-1 grid-column">
                                    {{
                                        "TransactionReport.TypeHeader"
                                            | translate
                                    }}
                                </div>
                                <div class="col-md-1 col-sm-1 grid-column">
                                    {{
                                        "TransactionReport.TransactionIdHeader"
                                            | translate
                                    }}
                                </div>
                                <div class="col-md-2 col-sm-2 grid-column">
                                    {{
                                        "TransactionReport.AmountHeader"
                                            | translate
                                    }}
                                </div>
                                <div class="col-md-1 col-sm-1 grid-column">
                                    {{
                                        "TransactionReport.PurchaseNumberHeader"
                                            | translate
                                    }}
                                </div>
                                <div class="col-md-3 col-sm-3 grid-column">
                                    {{
                                        "TransactionReport.PurchaseMemberNameHeader"
                                            | translate
                                    }}
                                </div>
                                <div class="col-md-2 col-sm-2 grid-column">
                                    {{
                                        "TransactionReport.PurchaseMemberIdHeader"
                                            | translate
                                    }}
                                </div>
                            </div>
                        </div>
                    }

                    @for (item of items; track item) {
                        <div
                            class="list-group-item list-group-item-action flex-column align-items-start clickable"
                        >
                            <app-transaction-report-item
                                hznTestId="transaction-report-row"
                                [item]="item"
                            ></app-transaction-report-item>
                        </div>
                    }
                    @if (noItems && !isBusy) {
                        <div class="no-items-info padding-20" hznTestId="transaction-report-no-items">
                            <span>{{
                                "TransactionReport.NoItems" | translate
                            }}</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
